import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer01 = new TileLayer({
    title: 'Máscara 20200905',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20200905l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer01.setVisible(false);
  
const layer02 = new TileLayer({
    title: 'Máscara 20201007',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20201007l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02.setVisible(false);
  
const layer02A = new TileLayer({
    title: 'Máscara 20201031',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20201031l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02A.setVisible(false);
  
const layer02B = new TileLayer({
    title: 'Máscara 20201202',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20201202l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02B.setVisible(false);
  
const layer02C = new TileLayer({
    title: 'Máscara 20201226',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20201226l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02C.setVisible(false);
  
const layer02D = new TileLayer({
    title: 'Máscara 20210103',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210103l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02D.setVisible(false);
  
const layer02E = new TileLayer({
    title: 'Máscara 20210111',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210111l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02E.setVisible(false);
  
const layer02F = new TileLayer({
    title: 'Máscara 20210212',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210212l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02F.setVisible(false);
  
const layer02G = new TileLayer({
    title: 'Máscara 20210316',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210316l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02G.setVisible(false);
  
const layer02H = new TileLayer({
    title: 'Máscara 20210519',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210519l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02H.setVisible(false);
  
const layer02I = new TileLayer({
    title: 'Máscara 20210628',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210628l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02I.setVisible(false);
  
const layer02J = new TileLayer({
    title: 'Máscara 20210706',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210706l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02J.setVisible(false);
  
const layer02K = new TileLayer({
    title: 'Máscara 20210714',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210714l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02K.setVisible(false);
  
const layer02L = new TileLayer({
    title: 'Máscara 20210722',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210722l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02L.setVisible(false);
  
const layer02M = new TileLayer({
    title: 'Máscara 20210730',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210730l8oli202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
  layer02M.setVisible(false);
  
const layer02N = new TileLayer({
    title: 'Máscara 20210823',
    source: new TileWMS({
      url: urlWMSInundaciones,
      params: {LAYERS: '20210823l7etm202_34_GRN1_inund', format: formatoPNG},
      gutter: 200,
    })
  });
layer02N.setVisible(false);

export const grupoCapa01 = new LayerGroup({
  title: 'Ciclo Hidrológico 2020-2021',
  fold: 'close',
  layers: [layer01, layer02, layer02A, layer02B, layer02C, layer02D, layer02E, layer02F, layer02G, layer02H, layer02I, layer02J, layer02K, layer02L, layer02M, layer02N]
});